function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/*!
 * zoomist.js v1.0.2
 * https://github.com/cotton123236/zoomist#readme
 *
 * Copyright 2021-present Wilson Wu
 * Released under the MIT license
 *
 * Date: 2022-03-26T09:56:17.746Z
 */
!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = "undefined" != typeof globalThis ? globalThis : t || self).Zoomist = e();
}(this, function () {
  "use strict";

  var t = "zoomist",
    e = ["slider", "zoomer"],
    o = "zoomist-container",
    i = "zoomist-slider",
    s = "zoomist-in-zoomer",
    n = "zoomist-out-zoomer",
    a = "zoomist-zoomer-disable",
    r = !(!("undefined" != typeof window && void 0 !== window.document) || !("ontouchstart" in window)),
    l = r ? "touchstart" : "mousedown",
    d = r ? "touchmove" : "mousemove",
    h = r ? "touchend" : "mouseup";
  var c = {
    fill: "cover",
    src: "data-zoomist-src",
    draggable: !0,
    wheelable: !0,
    pinchable: !0,
    bounds: !0,
    zoomRatio: .1,
    maxRatio: !1,
    height: "auto"
  };
  var m = {
      el: i,
      direction: "horizontal",
      maxRatio: 2
    },
    u = {
      inEl: s,
      outEl: n,
      disableOnBounds: !0
    },
    p = {
      ready: null,
      zoom: null,
      wheel: null,
      dragStart: null,
      drag: null,
      dragEnd: null,
      pinchStart: null,
      pinch: null,
      pinchEnd: null,
      slideStart: null,
      slide: null,
      slideEnd: null,
      resize: null,
      reset: null,
      destroy: null,
      update: null
    },
    g = function g(t, e) {
      t || (t = {});
      for (var _i = 0, _Object$entries = Object.entries(e); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          _o = _Object$entries$_i[0],
          _i2 = _Object$entries$_i[1];
        t[_o] = _i2;
      }
    },
    f = function f(t) {
      return Object.assign({}, t);
    },
    v = function v(t) {
      return "number" == typeof t && !isNaN(t);
    },
    w = function w(t) {
      return null !== z(t);
    },
    z = function z(t) {
      return t instanceof HTMLElement ? t : document.querySelector(t);
    },
    E = function E(t) {
      return w(t) && "IMG" === z(t).tagName;
    },
    _ = function _(t) {
      return "function" == typeof t;
    },
    y = function y(t, e) {
      for (var _i3 = 0, _Object$entries2 = Object.entries(e); _i3 < _Object$entries2.length; _i3++) {
        var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i3], 2),
          _o2 = _Object$entries2$_i[0],
          _i4 = _Object$entries2$_i[1];
        t.style[_o2] = v(_i4) ? "".concat(_i4, "px") : _i4;
      }
    },
    x = function x(t) {
      var e = !r || "wheel" === t.type;
      return {
        x: e ? t.pageX : t.touches[0].pageX,
        y: e ? t.pageY : t.touches[0].pageY,
        clientX: e ? t.clientX : t.touches[0].clientX,
        clientY: e ? t.clientY : t.touches[0].clientY
      };
    },
    b = function b(t) {
      var e = getComputedStyle(t).transform;
      var o = e.match(/^matrix3d\((.+)\)$/);
      return o ? parseFloat(o[1].split(", ")[12]) : (o = e.match(/^matrix\((.+)\)$/), o ? parseFloat(o[1].split(", ")[4]) : 0);
    },
    Y = function Y(t) {
      var e = getComputedStyle(t).transform;
      var o = e.match(/^matrix3d\((.+)\)$/);
      return o ? parseFloat(o[1].split(", ")[13]) : (o = e.match(/^matrix\((.+)\)$/), o ? parseFloat(o[1].split(", ")[5]) : 0);
    },
    L = function L(t) {
      return +(Math.round(t + "e+2") + "e-2");
    },
    X = function X(t, e, o) {
      return Math.min(Math.max(t, e), o);
    };
  var D = {
      getContainerData: function getContainerData() {
        return f(this.data.containerData);
      },
      getImageData: function getImageData() {
        return f(this.data.imageData);
      },
      getSliderValue: function getSliderValue() {
        var _this$__modules__$sli;
        return (_this$__modules__$sli = this.__modules__.slider) === null || _this$__modules__$sli === void 0 ? void 0 : _this$__modules__$sli.value;
      },
      getZoomRatio: function getZoomRatio() {
        return this.ratio;
      },
      zoom: function zoom(t, e) {
        var o = this.image,
          i = this.data,
          s = this.options,
          n = this.ratio,
          r = s.bounds,
          l = s.maxRatio;
        if (r && 1 === n && t < 0) return;
        if (l && n === l && t > 0) return;
        var d = i.originImageData,
          h = this.getContainerData(),
          c = this.getImageData(),
          m = o.getBoundingClientRect(),
          u = L(n * (t + 1)),
          p = r && u < 1 ? 1 : l && u > l ? l : u,
          f = p / n - 1,
          v = d.width * p,
          w = d.height * p,
          z = (h.width - v) / 2,
          E = (h.height - w) / 2,
          _ = e ? (c.width / 2 - e.clientX + m.left) * f + b(o) : b(o),
          x = e ? (c.height / 2 - e.clientY + m.top) * f + Y(o) : Y(o),
          D = r ? X(_, z, -z) : _,
          R = r ? X(x, E, -E) : x,
          O = {
            width: v,
            height: w,
            left: z,
            top: E
          };
        if (g(i.imageData, O), y(o, _objectSpread(_objectSpread({}, O), {}, {
          transform: "translate(".concat(D, "px, ").concat(R, "px)")
        })), this.ratio = p, this.emit("zoom", p), s.slider) {
          var _t = this.__modules__.slider,
            _e2 = 100 * L(1 - (_t.maxRatio - p) / (_t.maxRatio - 1));
          _t.value = X(_e2, 0, 100), this.slideTo(_e2, !0);
        }
        if (s.zoomer) {
          var _t2 = this.__modules__.zoomer;
          if (_t2.disableOnBounds) {
            var _t3 = s.bounds,
              _this$__modules__$zoo = this.__modules__.zoomer,
              _e3 = _this$__modules__$zoo.zoomerInEl,
              _o3 = _this$__modules__$zoo.zoomerOutEl;
            _t3 && 1 === this.ratio ? _o3.classList.add(a) : _o3.classList.remove(a), this.ratio === l ? _e3.classList.add(a) : _e3.classList.remove(a);
          }
        }
        return this;
      },
      zoomTo: function zoomTo(t) {
        var e = this.ratio;
        if (t !== e) {
          var _o4 = t / e - 1;
          this.zoom(_o4);
        }
        return this;
      },
      move: function move() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var o = this.image,
          i = this.data,
          s = this.options,
          n = i.imageData,
          a = i.dragData,
          r = n.top,
          l = n.left,
          d = a.transX,
          h = a.transY,
          c = s.bounds,
          m = c ? X(d - t, l, -l) : d - t,
          u = c ? X(h - e, r, -r) : h - e,
          p = L(m),
          f = L(u);
        return g(a, {
          transX: p,
          transY: f
        }), o.style.transform = "translate(".concat(p, "px, ").concat(f, "px)"), this;
      },
      moveTo: function moveTo(t, e) {
        var _t4, _e4;
        var o = this.data,
          i = this.options,
          s = o.imageData,
          n = o.dragData,
          a = s.top,
          r = s.left,
          l = n.transX,
          d = n.transY,
          h = i.bounds;
        t = (_t4 = t) !== null && _t4 !== void 0 ? _t4 : Math.abs(r), e = (_e4 = e) !== null && _e4 !== void 0 ? _e4 : Math.abs(a);
        var c = h ? X(r + t + l, r, -r) : r + t + l,
          m = h ? X(a + e + d, a, -a) : a + e + d;
        return this.move(c, m), this;
      },
      slideTo: function slideTo(t, e) {
        var o = this.__modules__;
        if (!o.slider) return;
        var i = o.slider,
          s = "horizontal" === i.direction ? "left" : "top",
          n = "horizontal" === i.direction ? "" : "-",
          a = X(t, 0, 100);
        if (i.sliderButton.style[s] = "".concat(n).concat(a, "%"), !e) {
          var _t5 = a / 100,
            _e5 = this.ratio < 1 ? this.ratio : 1,
            _o5 = ((this.ratio > i.maxRatio ? this.ratio : i.maxRatio) - _e5) * _t5 + _e5;
          this.zoomTo(_o5);
        }
        return this;
      },
      reset: function reset() {
        var t = this.image;
        return this.zoomTo(1), y(t, {
          transform: "translate(0, 0)"
        }), this.emit("reset"), this;
      },
      destroy: function destroy() {
        var e = this.element,
          i = this.wrapper,
          _this$__modules__ = this.__modules__,
          s = _this$__modules__.slider,
          n = _this$__modules__.zoomer;
        return e[t] = void 0, this.mounted = !1, s && this.destroySlider(), n && this.destroyZoomer(), i.remove(), e.style.removeProperty("width"), e.style.removeProperty("padding-bottom"), e.classList.remove(o), this.emit("destroy"), this;
      },
      update: function update() {
        return this.destroy().init(), this.emit("update"), this;
      },
      on: function on(t, e) {
        if (!_(e)) return this;
        var o = this.__events__;
        return t.split(" ").forEach(function (t) {
          o[t] || (o[t] = []), o[t].push(e);
        }), this;
      },
      emit: function emit() {
        var _this = this;
        for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
          t[_key] = arguments[_key];
        }
        var e = this.__events__,
          o = t[0],
          i = t.slice(1, t.length);
        return e[o] ? (e[o].forEach(function (t) {
          _(t) && t.apply(_this, i);
        }), this) : this;
      }
    },
    R = function R(t) {
      var e = t.element,
        o = t.wrapper,
        i = t.image,
        s = t.options,
        n = t.data,
        a = n.containerData,
        r = n.imageData,
        c = n.originImageData;
      window.addEventListener("resize", function () {
        if (a.width === e.offsetWidth) return;
        var o = e.offsetWidth / a.width,
          s = e.offsetHeight / a.height,
          n = c.width * o,
          l = c.height * s,
          d = c.left * o,
          h = c.top * s,
          m = r.width * o,
          u = r.height * s,
          p = r.left * o,
          f = r.top * s,
          v = b(i) * o,
          w = Y(i) * s;
        g(a, {
          width: e.offsetWidth,
          height: e.offsetHeight
        }), g(c, {
          width: n,
          height: l,
          left: d,
          top: h
        }), g(r, {
          width: m,
          height: u,
          left: p,
          top: f
        }), y(t.image, {
          width: m,
          height: u,
          left: p,
          top: f,
          transform: "translate(".concat(v, "px, ").concat(w, "px)")
        }), t.emit("resize");
      }), t.dragging = !1, t.data.dragData = {
        startX: 0,
        startY: 0,
        transX: 0,
        transY: 0
      }, "contain" === s.fill && s.bounds && (s.bounds = !1);
      var m = n.dragData,
        u = function u(e) {
          if (!t.dragging) return;
          var o = e.touches && 2 === e.touches.length,
            n = o ? (e.touches[0].pageX + e.touches[1].pageX) / 2 : x(e).x,
            a = o ? (e.touches[0].pageY + e.touches[1].pageY) / 2 : x(e).y;
          if (s.bounds) {
            var _t6 = m.startX - (m.transX - r.left),
              _e6 = m.startX - (m.transX + r.left),
              _o6 = m.startY - (m.transY - r.top),
              _i5 = m.startY - (m.transY + r.top);
            n < _t6 && (m.startX += n - _t6), n > _e6 && (m.startX += n - _e6), a < _o6 && (m.startY += a - _o6), a > _i5 && (m.startY += a - _i5);
          }
          var l = L(n - m.startX + m.transX),
            d = L(a - m.startY + m.transY);
          i.style.transform = "translate(".concat(l, "px, ").concat(d, "px)"), t.emit("drag", {
            x: l,
            y: d
          }, e);
        },
        p = function p(e) {
          t.dragging = !1, g(m, {
            transX: b(i),
            transY: Y(i)
          }), t.emit("dragEnd", {
            x: m.transX,
            y: m.transY
          }, e), document.removeEventListener(d, u), document.removeEventListener(h, p);
        };
      t.pinching = !1, t.data.pinchData = {
        dist: 0,
        startX: 0,
        startY: 0
      };
      var f = function f(e) {
          if (!t.pinching) return;
          var o = t.data.pinchData,
            i = Math.hypot(e.touches[0].pageX - e.touches[1].pageX, e.touches[0].pageY - e.touches[1].pageY),
            s = L((i - o.dist) / 100),
            n = {
              clientX: (e.touches[0].clientX + e.touches[1].clientX) / 2,
              clientY: (e.touches[0].clientY + e.touches[1].clientY) / 2
            };
          t.zoom(s, n), o.dist = i, t.emit("pinch", e);
        },
        v = function v(e) {
          t.pinching = !1, t.emit("pinchEnd", e), document.removeEventListener(d, f), document.removeEventListener(h, v);
        };
      o.addEventListener(l, function (e) {
        (function (e) {
          if (!s.draggable) return;
          if (2 === e.which || 3 === e.which) return;
          var o = e.touches && 2 === e.touches.length;
          g(m, {
            startX: o ? (e.touches[0].pageX + e.touches[1].pageX) / 2 : x(e).x,
            startY: o ? (e.touches[0].pageY + e.touches[1].pageY) / 2 : x(e).y,
            transX: b(i),
            transY: Y(i)
          }), t.dragging = !0, t.emit("dragStart", {
            x: m.transX,
            y: m.transY
          }, e), document.addEventListener(d, u), document.addEventListener(h, p);
        })(e), function (e) {
          if (!s.pinchable) return;
          if (!e.touches || 2 !== e.touches.length) return;
          var o = t.data.pinchData;
          g(o, {
            dist: Math.hypot(e.touches[0].pageX - e.touches[1].pageX, e.touches[0].pageY - e.touches[1].pageY),
            startX: e.touches[0].clientX,
            startY: e.touches[0].clientY
          }), t.pinching = !0, t.emit("pinchStart", e), document.addEventListener(d, f), document.addEventListener(h, v);
        }(e);
      }), t.wheeling = !1;
      o.addEventListener("wheel", function (e) {
        if (!s.wheelable) return;
        e.preventDefault();
        var o = s.zoomRatio;
        if (t.wheeling) return;
        var i;
        t.wheeling = !0, setTimeout(function () {
          t.wheeling = !1;
        }, 30), e.deltaY ? i = e.deltaY > 0 ? -1 : 1 : e.wheelDelta ? i = e.wheelDelta / 120 : e.detail && (i = e.detail > 0 ? -1 : 1), t.zoom(i * o, x(e)), t.emit("wheel", e);
      });
    };
  var O = {
    createModules: function createModules() {
      var _this2 = this;
      var t = this.options;
      this.__modules__ = {}, e.forEach(function (e) {
        var o;
        t[e] && _this2["create".concat((o = e, o.charAt(0).toUpperCase() + o.slice(1)))]();
      });
    },
    createSlider: function createSlider() {
      var t = this.element,
        e = this.options,
        o = this.__modules__;
      o.slider = Object.assign({}, m, e.slider);
      var s = o.slider;
      e.maxRatio && Object.assign(s, {
        maxRatio: e.maxRatio
      }), "horizontal" !== s.direction && "vertical" !== s.direction && (s.direction = "horizontal"), s.value = 0, s.mounted && s.sliderMain.remove();
      var n = s.isCustomEl = s.el && w(s.el),
        a = n ? z(s.el) : document.createElement("div");
      n || a.classList.add(i), a.innerHTML = '\n  <div class="zoomist-slider-main">\n    <span class="zoomist-slider-bar"></span>\n    <span class="zoomist-slider-button"></span>\n  </div>\n', s.sliderEl = a, s.sliderMain = a.querySelector(".zoomist-slider-main"), s.sliderBar = a.querySelector(".zoomist-slider-bar"), s.sliderButton = a.querySelector(".zoomist-slider-button"), s.sliderMain.classList.add("zoomist-slider-".concat(s.direction)), function (t) {
        var e = t.__modules__.slider;
        e.sliding = !1;
        var o = "horizontal" === e.direction,
          i = function i(_i6) {
            var s = e.sliderMain.getBoundingClientRect(),
              n = o ? x(_i6).clientX : -x(_i6).clientY,
              a = o ? s.width : s.height,
              r = o ? s.left : -s.bottom,
              l = X(L((n - r) / a), 0, 1),
              d = t.ratio < 1 ? t.ratio : 1,
              h = ((t.ratio > e.maxRatio ? t.ratio : e.maxRatio) - d) * l + d;
            t.zoomTo(h);
          },
          s = function s(o) {
            i(o), e.sliding = !0, t.emit("slideStart", t.getSliderValue(), o), document.addEventListener(d, n), document.addEventListener(h, a);
          },
          n = function n(o) {
            e.sliding && (i(o), t.emit("slide", t.getSliderValue(), o));
          },
          a = function a(o) {
            e.sliding = !1, t.emit("slideEnd", t.getSliderValue(), o), document.removeEventListener(d, n), document.removeEventListener(h, a);
          };
        e.sliderMain.addEventListener(l, s), e.sliderMain.event = s;
      }(this), s.mounted = !0, n || t.append(a);
    },
    destroySlider: function destroySlider() {
      var t = this.__modules__.slider;
      t && t.mounted && (t.isCustomEl ? t.sliderMain.remove() : t.sliderEl.remove(), t.mounted = !1);
    },
    createZoomer: function createZoomer() {
      var t = this.element,
        e = this.options,
        o = this.__modules__;
      o.zoomer = Object.assign({}, u, e.zoomer);
      var i = o.zoomer;
      i.mounted && i.zoomerEl && i.sliderMain.remove();
      var r = i.isCustomInEl = i.inEl && w(i.inEl),
        l = i.isCustomOutEl = i.outEl && w(i.outEl),
        d = r ? z(i.inEl) : document.createElement("div"),
        h = l ? z(i.outEl) : document.createElement("div");
      if (r || (d.classList.add(s), d.innerHTML = '\n<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 12 12">\n  <polygon points="12,5.5 6.5,5.5 6.5,0 5.5,0 5.5,5.5 0,5.5 0,6.5 5.5,6.5 5.5,12 6.5,12 6.5,6.5 12,6.5 "/>\n</svg>\n'), l || (h.classList.add(n), h.innerHTML = '\n<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 12 12">\n  <rect y="5.5" width="12" height="1"/>\n</svg>\n'), i.zoomerInEl = d, i.zoomerOutEl = h, i.disableOnBounds) {
        var _t7 = e.bounds,
          _o7 = e.maxRatio;
        _t7 && 1 === this.ratio && h.classList.add(a), this.ratio === _o7 && d.classList.add(a);
      }
      if (function (t) {
        var e = t.options.zoomRatio,
          o = t.__modules__.zoomer,
          i = function i() {
            return t.zoom(e);
          },
          s = function s() {
            return t.zoom(-e);
          };
        o.zoomerInEl.addEventListener("click", i), o.zoomerOutEl.addEventListener("click", s), o.zoomerInEl.event = i, o.zoomerOutEl.event = s;
      }(this), i.mounted = !0, !r || !l) {
        var _e7 = document.createElement("div");
        _e7.classList.add("zoomist-zoomer"), r || _e7.append(d), l || _e7.append(h), i.zoomerEl = _e7, t.append(_e7);
      }
    },
    destroyZoomer: function destroyZoomer() {
      var t = this.__modules__.zoomer;
      if (!t || !t.mounted) return;
      var e = function e(t) {
        t.removeEventListener("click", t.event), t.event = void 0, t.classList.remove(a);
      };
      t.isCustomInEl ? e(t.zoomerInEl) : t.zoomerInEl.remove(), t.isCustomOutEl ? e(t.zoomerOutEl) : t.zoomerOutEl.remove(), t.zoomerEl && t.zoomerEl.remove(), t.mounted = !1;
    }
  };
  var M = /*#__PURE__*/function () {
    function M(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      _classCallCheck(this, M);
      if (!t) throw new Error("The first argument is required.");
      if (!w(t)) throw new Error("This element is not exist.");
      this.element = z(t), this.options = Object.assign({}, c, function (t) {
        if (!function (t) {
          return "object" == _typeof(t) && null !== t;
        }(t)) return !1;
        try {
          var _e8 = t.constructor,
            _o8 = _e8.prototype,
            _i7 = Object.prototype.hasOwnProperty;
          return _e8 && _o8 && _i7.call(_o8, "isPrototypeOf");
        } catch (t) {
          return !1;
        }
      }(e) && e), this.init();
    }
    _createClass(M, [{
      key: "init",
      value: function init() {
        var e = this.element,
          o = this.options,
          i = o.src;
        if (e[t]) return;
        e[t] = this;
        var s = o.src = "string" == typeof (n = i) && "" !== n || E(i) ? i : c.src;
        var n;
        var a = E(s) ? s.src : e.getAttribute(s);
        if (!a) throw new Error("Cannot find src from ".concat(s));
        this.create(a);
      }
    }, {
      key: "create",
      value: function create(t) {
        if (!t) return;
        var e = this.options;
        if (this.url = t, this.data = {}, this.ratio = 1, this.__events__ = p, e.on) for (var _i8 = 0, _Object$entries3 = Object.entries(e.on); _i8 < _Object$entries3.length; _i8++) {
          var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i8], 2),
            _t8 = _Object$entries3$_i[0],
            _o9 = _Object$entries3$_i[1];
          this.__events__[_t8] = [_o9];
        }
        this.mount();
      }
    }, {
      key: "mount",
      value: function mount() {
        var _this3 = this;
        if (this.mounted) return;
        var t = this.element,
          e = this.options,
          o = this.data,
          i = this.url,
          s = e.fill,
          n = e.maxRatio,
          a = e.height;
        this.wrapper && this.wrapper.remove();
        var r = document.createElement("div");
        r.classList.add("zoomist-wrapper");
        var l = document.createElement("img");
        l.classList.add("zoomist-image"), l.src = i, l.onload = function () {
          _this3.wrapper = r, _this3.image = l;
          var i = l.naturalWidth,
            d = l.naturalHeight,
            h = i / d;
          a && (y(t, {
            width: "100%"
          }), "auto" === a ? y(t, {
            paddingBottom: "".concat(L(d / i * 100), "%")
          }) : v(a) ? y(t, {
            height: a
          }) : a.indexOf("%") > -1 && y(t, {
            paddingBottom: a
          }));
          var c = t.offsetWidth,
            m = t.offsetHeight;
          _this3.data.containerData = {
            width: c,
            height: m,
            aspectRatio: c / m
          };
          var u = o.containerData;
          var p;
          "cover" !== s && "contain" !== s && "none" !== s && (e.fill = "cover"), "contain" !== e.fill && (p = u.aspectRatio === h ? "both" : u.aspectRatio > h ? "width" : "height"), "contain" === e.fill && (p = u.aspectRatio === h ? "both" : u.aspectRatio > h ? "height" : "width");
          var g = "none" === e.fill ? i : "both" === p || "width" === p ? u.width : u.height * h,
            f = "none" === e.fill ? d : "both" === p || "height" === p ? u.height : u.width / h,
            w = (u.width - g) / 2,
            z = (u.height - f) / 2;
          _this3.data.originImageData = {
            naturalWidth: i,
            naturalHeight: d,
            aspectRatio: h,
            width: g,
            height: f,
            left: w,
            top: z
          }, _this3.data.imageData = Object.assign({}, _this3.data.originImageData), y(l, {
            width: g,
            height: f,
            left: w,
            top: z
          }), (!v(n) || n <= 1) && !1 !== n && (e.maxRatio = !1), R(_this3), _this3.mounted = !0, _this3.render();
        };
      }
    }, {
      key: "render",
      value: function render() {
        var t = this.element,
          e = this.wrapper,
          i = this.image;
        t.classList.add(o), e.append(i), t.append(e), this.createModules(), this.emit("ready");
      }
    }]);
    return M;
  }();
  return Object.assign(M.prototype, D, O), M;
});